<template>
<div :class="$style.main">
  <div v-show="noMapVisible" class="no_map_box">
    <p class="no_map_title"><label>데이터가 없습니다.</label></p>
    <p class="no_map_desc"><label>맵을 선택해 주십시오.</label></p>
  </div>
  <drop
    ref="graphArea"
    :class="[$style['graph-area'], 'graph-area']"
    @drop="dropHandler">
  </drop>
  <w-map-object-search v-if="!isInDashboardWidget && !isEditMode"></w-map-object-search>
  <w-map-controlbar v-if="!isInDashboardWidget"></w-map-controlbar>
  <w-refresh-timer v-if="!isInDashboardWidget && !isEditMode" v-show="!isAutomapDeviceTableExpand" @refresh="startRefreshObjResult" type="TOPOLOGYMAP"></w-refresh-timer>
</div>
</template>

<script>
import { isNil } from 'lodash';
import axios from 'axios';
import MapAPI from '@/api/topologymap/common';

import MenuDefine from '@/constants/menu';
import MapConst from '@/constants/topologymap';

import Base from '@/mixins/topologymap/base';

import { isEmpty } from '@/utils/basic';

import WMapControlbar from '@/views/topologymap/components/MapControlbar';
import WEventListWindow from '@/views/topologymap/components/monitoring/EventListWindow';
import WRefreshTimer from '@/views/dashboard/components/RefreshTimer';
import WMapObjectSearch from '@/views/topologymap/components/monitoring/MapObjectSearch';

import { Q, MapInfo, MapUtil, MapPopup } from '@/views/topologymap/js/maps';

import { Drop } from 'vue-drag-drop';

const REFRESH_TASK_NAME = 'refresh_obj_result';

export default {
  name: 'WTopologymapCanvas',
  mixins: [Base],
  components: {
    Drop,
    WRefreshTimer,
    WMapControlbar,
    WMapObjectSearch,
  },
  created() {
    // MapInfo.getInstance(this).setCanvas(this);
    // window.addEventListener('resize', this.updateZoom);
  },
  data() {
    return {
      refreshTimer: null,
      noMapVisible: false,
      webSocket: null,
      refreshObjResultCount: 30,
      isLoadingRefreshEvent: false,
      isLoadingRefreshObj: false,
      cancelTokenMap: null,
      cancelTokenEvent: null,
      cancelTokenObj: null,
    };
  },
  mounted() {
    MapInfo.getInstance(this).setCanvas(this);
    MapInfo.getInstance(this).addMapCompleteCallback(this.startTask);

    this.openWebSocket();
    this.createGraph();
    this.refreshMap(this.getRefreshMapParam().mapId, this.getRefreshMapParam().redirect, {
      objId: this.getRefreshMapParam().objId,
    });
  },
  beforeDestroy() {
    this.clearMap();
    this.closeWebSocket();

    // window.removeEventListener('resize', this.updateZoom);
  },
  watch: {
    /**
     * 라우트 변경을 감지하여 맵을 새로고침한다.
     * @author KangBonghun(toto1323)
     * @param  {[type]} to   [description]
     * @param  {[type]} from [description]
     */
    $route(to, from) {
      if (to.path !== from.path) {
        // 변경 된 경로가 이전과 다를 경우에만
        if (to.path.indexOf(MenuDefine.TOPOLOGYMAP) > -1 && to.params.treeKey) {
          // 토폴로지맵으로 라우팅 한 것인지 확인
          if (!this.isEditMode) {
            // 편지모드에서는 라우트가 변경되어도 맵을 새로고침하지 않는다.
            const ids = to.params.treeKey.split('.');
            const mapId = ids[ids.length - 1];

            if (!isNaN(mapId) && parseInt(this.currentMapId, 10) !== parseInt(mapId, 10)) {
              // 라우팅 된 맵이 현재 맵과 다를 경우에만 맵을 새로고침한다.
              this.refreshMap(mapId, to.query.redirect, {
                objId: to.query.objId,
                ipaddress: to.query.ipaddress,
                connectInfoParam: to.query.connectInfoParam,
              });
            }
          }
        }
      }
    },
  },
  methods: {
    dropHandler(dropObject, event) {
      try {
        if (!dropObject) {
          return;
        }

        const editToolbar = MapInfo.getInstance(this).getToolbar(MapConst.VIEW_MODE.EDIT);
        const graph = MapInfo.getInstance(this).getGraph();
        const localPoint = graph.globalToLocal(event);
        const logicalPoint = graph.toLogical(localPoint.x, localPoint.y);
        editToolbar.onDragAndDrop(dropObject.type, logicalPoint, dropObject.data, event);
      } catch (e) {
        throw new Error(e);
      }
    },
    /**
     * 맵을 새로고침하는데 사용되는 조건값을 반환한다.
     * @author KangBonghun(toto1323)
     * @return {Object} 맵 새로고침 조건
     */
    getRefreshMapParam() {
      let mapId = -1;
      let redirect = true;
      let fit = false;
      let interaction = MapConst.INTERACTION.MONITORING;
      let objId = null;
      const refreshOptions = this.$store.getters.getRefreshOptions;
      if (!isEmpty(refreshOptions)) {
        if (!isEmpty(refreshOptions.mapId)) {
          mapId = parseInt(refreshOptions.mapId, 10);
        }

        if (!isEmpty(refreshOptions.mapId)) {
          redirect = false;
        }

        if (!isEmpty(refreshOptions.fit)) {
          fit = refreshOptions.fit === true;
        }

        if (!isEmpty(refreshOptions.action)) {
          interaction = refreshOptions.action === true ? MapConst.INTERACTION.MONITORING : MapConst.INTERACTION.NO_ACTION;
        }
      } else {
        if (this.$route.query.mapId) {
          mapId = parseInt(this.$route.query.mapId, 10);
        } else if (this.$route.params.treeKey) {
          const ids = this.$route.params.treeKey.split('.');
          mapId = ids[ids.length - 1];
        }
        // 마지막으로 봤던 맵을 보여주는 기능 제거
        // else if (sessionStorage.getItem('mapId')) {
        //   mapId = parseInt(sessionStorage.getItem('mapId'), 10);
        // }

        if (MapUtil.isFullScreen()) {
          fit = true;
        }

        if (this.$route.query.fit) {
          fit = this.$route.query.fit === 'true';
        }

        if (this.$route.query.action) {
          interaction = this.$route.query.action === 'true' ? MapConst.INTERACTION.MONITORING : MapConst.INTERACTION.NO_ACTION;
        }
        if (this.$route.params.objId) {
          objId = Number(this.$route.params.objId);
        } else if (this.$route.query.objId) {
          objId = Number(this.$route.query.objId);
        }
      }


      return {
        mapId, // 맵 아이디
        redirect, // 새로고침하는 맵에 권한이 없을 경우 리다이렉션 여부
        fit, // 자동 확대/축소 여부
        interaction, // 인터렉션 모드
        objId, // 자동선택 관리대상 아이디
      };
    },
    /**
     * 웹소켓을 연결한다.
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    openWebSocket() {
      // 웹소켓 연결하기전에 정리한다.
      this.closeWebSocket();

      const protocol = window.location.protocol.indexOf('https') > -1 ? 'wss' : 'ws';

      this.webSocket = new WebSocket(`${protocol}://${window.location.host}/update-event.do`);

      if (this.webSocket) {
        this.webSocket.onmessage = (e) => {
          const graph = MapInfo.getInstance(this).getGraph();
          if (graph && !graph.editable && graph.topologymapModel && graph.topologymapModel.mapId) {
            if (e.data === 'NEW_EVENT') {
              this.refreshEvent();
            }
          }
        };
        this.webSocket.onopen = () => {
          console.log('Topologymap WebSocket opened');
        };
        this.webSocket.onclose = () => {
          console.log('Topologymap WebSocket closed');
        };
      }
    },
    /**
     * 웹소켓 연결을 해제한다.
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    closeWebSocket() {
      if (this.webSocket) {
        this.webSocket.close();
        this.webSocket = null;
      }
    },
    /**
     * 오브젝트를 그리기 위한 그래프(Canvas)를 생성한다.
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    createGraph() {
      const graph = new Q.Graph(this.$refs.graphArea.$el);
      graph.originAtCenter = false;
      graph.enableTooltip = true;
      graph.tooltipDelay = 0;
      graph.tooltipDuration = 5000;
      graph.editable = false;
      graph.interactionMode = this.getRefreshMapParam().interaction;
      graph.enableDoubleClickToOverview = false;

      Q.Defaults.DOUBLE_CLICK_INTERVAL_TIME = 400;
      Q.Defaults.LONG_PRESS_INTERVAL = 200;

      // 배경 격자
      graph.background = new Q.Background(graph);

      // 회선 애니메이션
      graph.flowingSupport = new Q.FlowingSupport(graph);

      // 장애 애니메이션
      graph.eventEffectSupport = new Q.EventEffectSupport(graph);

      // Radial Layouter
      const radialLayouter = new Q.SpringLayouter(graph);
      radialLayouter.repulsion = 150;
      radialLayouter.attractive = 0.5;
      radialLayouter.elastic = 3;
      graph.radialLayouter = radialLayouter;

      // Circle Layouter
      const circleLayouter = new Q.BalloonLayouter(graph);
      circleLayouter.radius = 200;
      circleLayouter.gap = -40;
      graph.circleLayouter = circleLayouter;

      // Tree Layouter
      const treeLayouter = new Q.TreeLayouter(graph);
      graph.treeLayouter = treeLayouter;

      // Hierarchic Layouter
      const hierarchicLayouter = new Q.HierarchicLayouter(graph);
      graph.hierarchicLayouter = hierarchicLayouter;

      // 기본 스타일
      const defaultStyles = {};
      defaultStyles[Q.Styles.ARROW_TO] = false;
      defaultStyles[Q.Styles.ARROW_FROM] = false;
      defaultStyles[Q.Styles.EDGE_WIDTH] = 1;
      defaultStyles[Q.Styles.SELECTION_COLOR] = null;

      graph.styles = defaultStyles;

      // 오브젝트 속성이 변경되면 Model에도 동기화한다.
      graph.dataPropertyChangeDispatcher.addListener((evt) => {
        // 관련 없는 속성 변경은 무시한다.
        switch (evt.kind) {
          case 'invalidate':
          case 'render.color':
          case 'edge.color':
          case 'edge.width':
          case 'edgeType':
          case 'edge.line.dash':
          case 'label.visible':
          case 'srcInValue':
          case 'srcOutValue':
          case 'dstInValue':
          case 'dstOutValue':
          case 'zIndex':
          case 'tooltip':
          case 'label.background.color':
          case 'label.color':
          case 'label.font.size':
          case 'label.font.family':
          case 'label.font.style':
          case 'label.position':
          case 'label.anchor.position':
          case 'image.background.color':
          case 'image.border.style':
          case 'image.padding':
          case 'image.border.width':
          case 'image.radius':
          case 'add':
            return;
          default:
        }

        if (evt.source.onChangeProperty) {
          evt.source.onChangeProperty(evt);
        }
      });

      // 오브젝트 선택 되었을 때 효과 설정
      const setSelectionStyle = (element) => {
        if (!(element instanceof Q.Node)) {
          return;
        }
        const selected = graph.isSelected(element);
        if (selected) {
          if (element instanceof Q.LabelModel) {
            element.setStyle(Q.Styles.LABEL_BACKGROUND_COLOR, 'rgba(171,216,255,0.15)');
            element.setStyle(Q.Styles.LABEL_BORDER_STYLE, '#5db5ff');
            element.setStyle(Q.Styles.LABEL_PADDING, 0);
            element.setStyle(Q.Styles.LABEL_BORDER, 1);
            element.setStyle(Q.Styles.LABEL_RADIUS, 3);
          } else {
            element.setStyle(Q.Styles.IMAGE_BACKGROUND_COLOR, 'rgba(171,216,255,0.15)');
            element.setStyle(Q.Styles.IMAGE_BORDER_COLOR, '#5db5ff');
            element.setStyle(Q.Styles.IMAGE_PADDING, 0);
            element.setStyle(Q.Styles.IMAGE_BORDER, 1);
            element.setStyle(Q.Styles.IMAGE_BORDER_RADIUS, 3);

            const model = element.get('model');
            if (model.styleOptions && model.styleOptions.imageType && model.styleOptions.imageType === 'widget') {
              element.setStyle(Q.Styles.IMAGE_PADDING, 0);
            }
          }
        } else if (element instanceof Q.LabelModel) {
          element.setStyle(Q.Styles.LABEL_BACKGROUND_COLOR, null);
          element.setStyle(Q.Styles.LABEL_BORDER_STYLE, null);
          element.setStyle(Q.Styles.LABEL_PADDING, 0);
          element.setStyle(Q.Styles.LABEL_BORDER, 0);
          element.setStyle(Q.Styles.LABEL_RADIUS, 3);
        } else {
          element.setStyle(Q.Styles.IMAGE_BACKGROUND_COLOR, null);
          element.setStyle(Q.Styles.IMAGE_BORDER_COLOR, null);
          element.setStyle(Q.Styles.IMAGE_PADDING, 0);
          element.setStyle(Q.Styles.IMAGE_BORDER, 0);
          element.setStyle(Q.Styles.IMAGE_BORDER_RADIUS, 3);
        }
      };

      graph.selectionChangeDispatcher.addListener((evt) => {
        const data = evt.data;
        if (!data) {
          return;
        }
        if (Q.isArray(data)) {
          for (let i = 0, l = data.length; i < l; i += 1) {
            setSelectionStyle(data[i]);
          }
        } else {
          setSelectionStyle(data);
        }
      });
      MapInfo.getInstance(this).setGraph(graph);

      return graph;
    },

    /**
     * 맵을 새로고침한다.
     * @author KangBonghun(toto1323)
     * @param  {[type]}   mapId    맵 아이디
     * @param  {[type]}   redirect 새로고침하는 맵에 권한이 없을 경우 권한이 있는 첫번째 맵으로 리다이렉션 여부
     * @param  {[type]}   obj    맵 이동 후 포커싱을 할 오브젝트의 관리대상 정보
     * @param  {Function} callback 맵을 성공적으로 새로고침 후 호출되는 콜백함수
     */
    refreshMap(mapId, redirect, obj, callback) {
      // 맵을 새로고침 하기 전 정리가 필요한 것들을 수행한다.
      this.clearMap();

      if (isNaN(mapId)) {
        if (redirect) {
          mapId = -1; // eslint-disable-line no-param-reassign
        } else {
          throw Error(`Invalid map id : ${mapId}`);
        }
      }

      window.stime1 = new Date().getTime();

      const graph = MapInfo.getInstance(this).getGraph();

      // MapInfo.getInstance(this).mask('로딩중...');

      this.cancelToken(this.cancelTokenMap);
      this.cancelTokenMap = axios.CancelToken.source();

      MapAPI.getTopologymap(mapId || -1, redirect || false, this.cancelTokenMap.token).then((response) => {
        const result = response.data;
        if (result.success) {
          window.etime1 = new Date().getTime();
          window.stime2 = new Date().getTime();
          window.time3 = result.data.latency;

          try {
            const topologymap = result.data.topologymap;
            const customimage = result.data.customimage;
            const eventlevel = result.data.eventlevel;
            const breadcrumb = result.data.breadcrumb;
            const automapInfo = result.data.automapInfo;

            // 전역변수에 사용자이미지, 이벤트 등급, 맵 경로 정보를 저장한다.
            this.$store.commit('setCustomimage', customimage);
            this.$store.commit('setEventlevel', eventlevel);
            this.$store.commit('setBreadcrumb', breadcrumb);
            this.$store.commit('setCurrentMapId', topologymap ? topologymap.mapId : null);
            this.$store.commit('setAutomapInfo', automapInfo);
            // 맵 트리 노드 선택
            this.$mapEventBus.$emit(MapConst.MAP_EVENTBUS.TREE_SELECT_NODE, breadcrumb.map((item) => item.mapId).join('.'));

            // 토폴로지맵 세팅
            if (topologymap) {
              graph.topologymapModel = topologymap;

              const modelData = {
                imageModels: topologymap.imageModels || [],
                labelModels: topologymap.labelModels || [],
                lanModels: topologymap.lanModels || [],
                managedObjectModels: topologymap.managedObjectModels || [],
                shapeModels: topologymap.shapeModels || [],
                subTopologymapModels: topologymap.subTopologymapModels || [],
                virtualLanModels: topologymap.virtualLanModels || [],
                virtualObjectModels: topologymap.virtualObjectModels || [],
                custom1Models: topologymap.custom1Models || [],
              };

              this.refreshGraphModel(modelData, true);
              this.initSelect(graph, obj);

              // sessionStorage.setItem('mapId', mapId);

              if (callback) {
                callback.call();
              }
            } else {
              graph.topologymapModel = null;
              this.refreshGraphModel({});
              MapPopup.closeAndHideAll();
            }
          } catch (e) {
            Q.log(e);
          } finally {
            if (graph.topologymapModel) {
              this.noMapVisible = false;
            } else {
              this.noMapVisible = true;
            }
          }
        }
      });
    },
    /**
     * 그래프 모델을 갱신한다.
     * @author KangBonghun(toto1323)
     * @param  {[type]} modelData [description]
     * @return {[type]}           [description]
     */
    refreshGraphModel(modelData, byAnimate) {
      const graph = MapInfo.getInstance(this).getGraph();

      // 새로운 GraphModel 객체에 담은 후 Graph에 대입한다.
      const graphModel = new Q.GraphModel();
      this.createImage(graphModel, modelData.imageModels);
      this.createSubTopologymap(graphModel, modelData.subTopologymapModels);
      this.createVirtualObject(graphModel, modelData.virtualObjectModels);
      this.createCustoms(graphModel, modelData.custom1Models);
      this.createVirtualLan(graphModel, modelData.virtualLanModels);
      this.createManagedObject(graphModel, modelData.managedObjectModels);
      this.createShape(graphModel, modelData.shapeModels);
      this.createLabel(graphModel, modelData.labelModels);
      this.createLan(graphModel, modelData.lanModels);

      // 기존 모델 Clear
      graph.graphModel.clear();
      graph.graphModel = graphModel;

      // 자동맵인데 사용자가 편집한 적이 없으면 기본적으로 Radial Layouter로 표현
      if (graph.topologymapModel && graph.topologymapModel.scheduleId && !graph.topologymapModel.customChngDatetime) {
        this.doAutoLayout(MapConst.LAYOUT_TYPE.RADIAL, byAnimate);
      }

      // Model 랜더 완료 콜백
      graph.callLater(() => {
        this.relocateNonePositionElements(graph);

        // 변경 이력 초기화
        MapInfo.getInstance(this).clearEditHistoryStack();
        // 로딩 마스크 제거
        // MapInfo.getInstance(this).unmask();
        // 맵을 새로고침 후에 필요한 각종 후속조치들을 수행한다.
        MapInfo.getInstance(this).callMapCompleteCallback();

        // 배경 업데이트
        graph.background.changeModel();

        graph.flowingSupport.start(30);
        graph.eventEffectSupport.start(30);

        window.etime2 = new Date().getTime();

        if (window.stime1) {
          const total = (window.etime1 - window.stime1) + (window.etime2 - window.stime2);
          console.log(`[맵 새로고침] 조회: ${window.time3} / 다운로드: ${(window.etime1 - window.stime1) - window.time3} / 랜더링: ${window.etime2 - window.stime2} / 총: ${total} ms`);
        }

        window.stime1 = null;
        window.etime1 = null;
        window.stime2 = null;
        window.etime2 = null;
      });
    },
    /**
     * 위치(x, y)가 정의되어 있지 않은 오브젝트 위치를 재배치한다.
     * @author KangBongHun(toto1323)
     * @return {[type]} [description]
     */
    relocateNonePositionElements(graph) {
      if (graph && graph.bounds) {
        const { x, y } = graph.bounds;

        let nodeSize = 0;
        const nonePositionElements = [];
        graph.graphModel.forEachNode((element) => {
          nodeSize += 1;
          if (isNil(element.get('x')) || isNil(element.get('y'))) {
            nonePositionElements.push(element);
          }
        });

        if (!isEmpty(nonePositionElements)) {
          // 모든 오브젝트가 위치가 없다면 자동 레이아웃으로 표현해준다.
          if (nonePositionElements.length === nodeSize) {
            this.doAutoLayout(MapConst.LAYOUT_TYPE.RADIAL, false);
          } else {
            const gap = (46 + 10); // 장비간 공백
            const col = nonePositionElements.length > 10 ? 10 : nonePositionElements.length % 10;
            const row = Math.ceil(nonePositionElements.length / 10);
            const rx = x - (col * gap); // 재배치 할 장비의 시작 X 좌표
            const ry = y - (row * gap); // 재배치 할 장비의 시작 Y 좌표

            let idx = 0;
            nonePositionElements.forEach((element) => {
              element.x = rx + (gap * (idx % 10));
              element.y = ry + (gap * parseInt(idx / 10, 10));
              idx += 1;
            });
          }
        }
      }
    },
    /**
     * AutoLayout 그리기
     * @author KangBongHun(toto1323)
     * @param  {[type]} layouter  [description]
     * @param  {[type]} byAnimate [description]
     * @return {[type]}           [description]
     */
    doAutoLayout(type, byAnimate) {
      const graph = MapInfo.getInstance(this).getGraph();

      let layouter;
      if (type === MapConst.LAYOUT_TYPE.RADIAL) {
        layouter = graph.radialLayouter;
      } else if (type === MapConst.LAYOUT_TYPE.CIRCLE) {
        layouter = graph.circleLayouter;
      } else if (type === MapConst.LAYOUT_TYPE.TREE) {
        layouter = graph.treeLayouter;
      } else if (type === MapConst.LAYOUT_TYPE.HIERARCHIC) {
        layouter = graph.hierarchicLayouter;
      }

      if (layouter) {
        layouter.doLayout({
          byAnimate: !!byAnimate,
          callback: () => {
            layouter.graph.callLater(() => {
              // 레이아웃이 그려진 후 그려진 좌표와 model 좌표가 다르다. 따라서 강제로 위치를 이동시켜서 좌표를 동기화시킨다.
              // 이렇게 하지 않으면 레이아웃이 그려진 후 model의 update 함수가 호출되었을 때 위치가 이상한 곳으로 바뀐다.
              layouter.graph.moveElements(layouter.graph.graphModel.toDatas(), 1, 1);
              layouter.graph.zoomToOverview(true);
            });
          },
        });
      } else {
        this.refreshMap(this.currentMapId);
      }
    },
    startTask() {
      this.startRefreshObjResult();
      this.refreshEvent();
    },
    /**
     * 관리대상 성능,범례 정보를 조회하는 Interval을 시작한다.
     * 주기는 30초이다.
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    startRefreshObjResult() {
      const graph = MapInfo.getInstance(this).getGraph();

      this.clearRefreshObjResult();

      this.refreshObjResult();
      this.refreshEvent();

      if (graph && !this.isEditMode) {
        this.refreshObjResultCount = 30;

        this.$taskManager.createTask(REFRESH_TASK_NAME, 1, this.countDownRefreshObjResult);
        this.$taskManager.startTask(REFRESH_TASK_NAME);
      }
    },
    clearRefreshObjResult() {
      this.refreshObjResultCount = null;
      if (this.$taskManager.existTask(REFRESH_TASK_NAME)) {
        this.$taskManager.removeTask(REFRESH_TASK_NAME);
      }
      this.$mapEventBus.$emit(MapConst.MAP_EVENTBUS.REFRESH_TIMER, 0);
    },
    countDownRefreshObjResult() {
      if (this.refreshObjResultCount !== null) {
        if (this.refreshObjResultCount === 0) {
          this.refreshObjResult();
          this.refreshEvent();
          this.refreshObjResultCount = 30;
        }

        this.$mapEventBus.$emit(MapConst.MAP_EVENTBUS.REFRESH_TIMER, this.refreshObjResultCount);

        if (!isNaN(this.refreshObjResultCount) && this.refreshObjResultCount !== 0 && this.refreshObjResultCount > 0) {
          this.refreshObjResultCount -= 1;
        }
      }
    },
    /**
     * 관리대상의 성능, 범례 정보를 조회한다.
     * @author KangBonghun(toto1323)
     */
    refreshObjResult() {
      try {
        if (this.isEditMode || this.isLoadingRefreshObj || MapInfo.getInstance(this).getPanel().loading) {
          return;
        }

        const graph = MapInfo.getInstance(this).getGraph();
        const topologymapModel = graph.topologymapModel;
        const graphModel = graph.graphModel;

        this.cancelToken(this.cancelTokenObj);
        this.cancelTokenObj = axios.CancelToken.source();

        this.isLoadingRefreshObj = true;
        MapAPI.getObjResultInMap(topologymapModel.mapId, this.cancelTokenObj.token).then((response) => {
          const result = response.data;
          if (result.success) {
            const legend = result.data.legend;
            const resource = result.data.resource;

            if (legend && resource) {
              graphModel.forEach((model) => {
                if (model.updateLegend) {
                  model.updateLegend(legend[model.id]);
                }
                if (model.updateResource) {
                  model.updateResource(resource[model.id]);
                }

                if (model instanceof Q.ManagedObjectModel || model instanceof Q.LanModel) {
                  model.tooltip = '';
                }
              });
            }
          }
        }).finally(() => {
          this.isLoadingRefreshObj = false;
        });
      } catch (e) {
        // ignore
      }
    },
    /**
     * 현재 맵의 이벤트 발생 상태를 새로고침한다.
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    refreshEvent() {
      try {
        if (this.isEditMode || this.isLoadingRefreshEvent || MapInfo.getInstance(this).getPanel().loading) {
          return;
        }

        const graph = MapInfo.getInstance(this).getGraph();
        const topologymapModel = graph.topologymapModel;
        const graphModel = graph.graphModel;

        this.cancelToken(this.cancelTokenEvent);
        this.cancelTokenEvent = axios.CancelToken.source();

        this.isLoadingRefreshEvent = true;
        MapAPI.getEventInMap(topologymapModel.mapId, this.cancelTokenEvent.token).then((response) => {
          const result = response.data;
          if (result.success) {
            const eventMap = result.data;
            graphModel.forEach((model) => {
              const eventStatus = eventMap[model.id];

              if (model.updateEvent) {
                model.updateEvent(eventStatus);
              }
            });
          }
        }).finally(() => {
          this.isLoadingRefreshEvent = false;
        });
      } catch (e) {
        // ignore
      }
    },
    /**
     * 맵 이동 후 오브젝트 포커싱
     * @author KangBonghun(toto1323)
     * @param  {[type]} graph [description]
     * @param  {[type]} objId [description]
     * @return {[type]}       [description]
     */
    initSelect(graph, obj) {
      const { objId, ipaddress, connectInfoParam } = obj || {};

      if (objId || ipaddress) {
        graph.callLater(() => {
          let item;
          graph.graphModel.toDatas().forEach((element) => {
            if (objId) {
              if (objId === element.get('objId')) {
                item = graph.graphModel.getById(element.id);
              }
            } else if (ipaddress) {
              if (ipaddress === element.get('ipaddress')) {
                item = graph.graphModel.getById(element.id);
              }
            }
          });

          if (item) {
            graph.setSelection(item);
            graph.sendToTop(item);
            const bounds = graph.getUIBounds(item);
            if (bounds) {
              graph.centerTo(bounds.cx, bounds.cy, Math.max(1, graph.scale), true);
            }

            const highlightElements = [item];
            if (connectInfoParam) {
              item.forEachEdge((edge) => {
                if (edge.from.get('model').ipaddress === connectInfoParam.ipaddress) {
                  highlightElements.push(edge.from);
                  highlightElements.push(edge);
                }
                if (edge.to.get('model').ipaddress === connectInfoParam.ipaddress) {
                  highlightElements.push(edge.to);
                  highlightElements.push(edge);
                }
              });
            }
            MapInfo.getInstance(this).highlightElements(highlightElements);
            MapInfo.getInstance(this).getToolbar(MapConst.VIEW_MODE.MONITORING).onClickTarget(null, item);
          }
        });
      }
    },
    /**
     * 맵을 새로고치기 전 정리가 필요한 부분을 정리한다.
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    clearMap() {
      MapPopup.closeAndHide(WEventListWindow.name);

      MapInfo.getInstance(this).callMapClearCallback();
      MapInfo.getInstance(this).getGraph().flowingSupport.stop();
      MapInfo.getInstance(this).getGraph().eventEffectSupport.stop();

      this.clearRefreshObjResult();

      this.isLoadingRefreshEvent = false;
      this.isLoadingRefreshObj = false;

      this.cancelToken(this.cancelTokenMap);
      this.cancelToken(this.cancelTokenEvent);
      this.cancelToken(this.cancelTokenObj);

      this.$mapEventBus.$emit(MapConst.MAP_EVENTBUS.REFRESH_TIMER, null);
      // 장비주요정보 팝업창 close
      this.$mapEventBus.$emit(MapConst.MAP_EVENTBUS.MAJOR_INFO, null);
      this.$mapEventBus.$emit(MapConst.MAP_EVENTBUS.AUTOMAP_MAJOR_INFO, null);
      // 자동맵 연결장비 목록 창 Close
      this.$mapEventBus.$emit(MapConst.MAP_EVENTBUS.AUTOMAP_DEVICE_VISIBLE, false);

      // 맵 표현 설정에 사용된다.
      window.filterLayerEnable = false;
    },
    /**
     * 이미지 오브젝트를 생성한다.
     * @param  {[type]} graphModel 오브젝트를 추가 할 GraphModel
     * @param  {[type]} images     이미지 오브젝트 목록
     * @return {[type]}            [description]
     */
    createImage(graphModel, images) {
      try {
        if (images) {
          images.forEach((item) => {
            const element = new Q.ImageModel(item);

            graphModel.add(element);
          });
        }
      } catch (e) {
        Q.log(e);
      }
    },
    /**
     * 라벨 오브젝트를 생성한다.
     * @param  {[type]} graphModel 오브젝트를 추가 할 GraphModel
     * @param  {[type]} labels     라벨(텍스트) 오브젝트 목록
     * @return {[type]}            [description]
     */
    createLabel(graphModel, labels) {
      try {
        if (labels) {
          labels.forEach((item) => {
            const element = new Q.LabelModel(item);

            graphModel.add(element);
          });
        }
      } catch (e) {
        Q.log(e);
      }
    },
    /**
     * 하위상황판 오브젝트를 생성한다.
     * @param  {[type]} graphModel      오브젝트를 추가 할 GraphModel
     * @param  {[type]} subTopologymaps 하위상황판 오브젝트 목록
     * @return {[type]}                 [description]
     */
    createSubTopologymap(graphModel, subTopologymaps) {
      try {
        if (subTopologymaps) {
          subTopologymaps.forEach((item) => {
            const element = new Q.SubTopologymapModel(item);

            graphModel.add(element);
          });
        }
      } catch (e) {
        Q.log(e);
      }
    },
    /**
     * 가상랜 오브젝트를 생성한다.
     * @param  {[type]} graphModel  오브젝트를 추가 할 GraphModel
     * @param  {[type]} virtualLans 가상랜 오브젝트 목록
     * @return {[type]}             [description]
     */
    createVirtualLan(graphModel, virtualLans) {
      try {
        if (virtualLans) {
          virtualLans.forEach((item) => {
            const element = new Q.VirtualLanModel(item);

            graphModel.add(element);
          });
        }
      } catch (e) {
        Q.log(e);
      }
    },
    /**
     * 가상객체 오브젝트를 생성한다.
     * @param  {[type]} graphModel     오브젝트를 추가 할 GraphModel
     * @param  {[type]} virtualObjects 가상객체 오브젝트 목록
     * @return {[type]}                [description]
     */
    createVirtualObject(graphModel, virtualObjects) {
      try {
        if (virtualObjects) {
          virtualObjects.forEach((item) => {
            const element = new Q.VirtualObjectModel(item);

            graphModel.add(element);
          });
        }
      } catch (e) {
        Q.log(e);
      }
    },
    /**
     * 사용자정의 오브젝트를 생성한다.
     * @param  {[type]} graphModel     오브젝트를 추가 할 GraphModel
     * @param  {[type]} virtualObjects 가상객체 오브젝트 목록
     * @return {[type]}                [description]
     */
    createCustoms(graphModel, customs) {
      try {
        if (customs) {
          customs.forEach((item) => {
            const element = new Q.Custom1Model(item);

            graphModel.add(element);
          });
        }
      } catch (e) {
        Q.log(e);
      }
    },
    /**
     * 관리객체 오브젝트를 생성한다.
     * @param  {[type]} graphModel     오브젝트를 추가 할 GraphModel
     * @param  {[type]} managedObjects 관리객체 오브젝트 목록
     * @return {[type]}                [description]
     */
    createManagedObject(graphModel, managedObjects) {
      try {
        if (managedObjects) {
          managedObjects.forEach((item) => {
            const element = new Q.ManagedObjectModel(item);
            graphModel.add(element);
          });
        }
      } catch (e) {
        Q.log(e);
      }
    },
    /**
     * 도형 오브젝트를 생성한다.
     * @param  {[type]} graphModel  오브젝트를 추가 할 GraphModel
     * @param  {[type]} shapeModels 도형 오브젝트 목록
     * @return {[type]}             [description]
     */
    createShape(graphModel, shapeModels) {
      try {
        if (shapeModels) {
          shapeModels.forEach((item) => {
            const element = new Q.ShapeModel(item);

            graphModel.add(element);
          });
        }
      } catch (e) {
        Q.log(e);
      }
    },
    /**
     * 선 오브젝트를 생성한다.
     * @param  {[type]} graphModel 오브젝트를 추가 할 GraphModel
     * @param  {[type]} lans       선 오브젝트 목록
     * @return {[type]}            [description]
     */
    createLan(graphModel, lans) {
      try {
        if (lans) {
          lans.forEach((item) => {
            const srcNode = graphModel.getById(item.srcElementId); // 출발지 오브젝트
            const dstNode = graphModel.getById(item.dstElementId); // 목적지 오브젝트

            // 선은 두 오브젝트를 연결시키므로 출발지/목적지 오브젝트가 필요하다.
            if (srcNode && dstNode) {
              const element = new Q.LanModel(item, srcNode, dstNode);
              graphModel.add(element);
            }
          });
        }
      } catch (e) {
        Q.log(e);
      }
    },
    /**
     * 화면을 확대한다.
     */
    zoomIn() {
      try {
        MapInfo.getInstance(this).getGraph().zoomIn();
      } catch (e) {
        Q.log(e);
      }
    },
    /**
     * 화면을 축소한다.
     */
    zoomOut() {
      try {
        MapInfo.getInstance(this).getGraph().zoomOut();
      } catch (e) {
        Q.log(e);
      }
    },
    /**
     * 확대/축소를 초기화한다.
     */
    zoomReset() {
      try {
        const topologymap = MapInfo.getInstance(this).getGraph().topologymapModel || {};

        if (MapInfo.getInstance(this).isViewPin()) {
          MapInfo.getInstance(this).getGraph().translateTo(topologymap.x || 0, topologymap.y || 0, topologymap.mapScale || 1);
        } else {
          MapInfo.getInstance(this).getGraph().moveToCenter(topologymap.mapScale || 1, false);
        }
      } catch (e) {
        Q.log(e);
      }
    },
    /**
     * 화면에 구성 된 요소룰 화면에 꽉 차도록 자동 확대/축소한다.
     */
    zoomFit() {
      try {
        MapInfo.getInstance(this).getGraph().zoomToOverview();
      } catch (e) {
        Q.log(e);
      }
    },

    /**
     * 전체화면으로 전환한다.
     */
    fullScreen() {
      try {
        const panel = MapInfo.getInstance(this).getPanel().$el;
        if (panel.requestFullScreen) {
          panel.requestFullScreen();
        } else if (panel.webkitRequestFullScreen) {
          panel.webkitRequestFullScreen();
        } else if (panel.mozRequestFullScreen) {
          panel.mozRequestFullScreen();
        } else if (panel.msRequestFullscreen) {
          panel.msRequestFullscreen(); // IE
        }
      } catch (e) {
        Q.log(e);
      }
    },
    /**
     * 전체화면 취소
     * @author {name}
     * @return {[type]} [description]
     */
    exitFullScreen() {
      try {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.webkitExitFullscreen) {
          document.webkitExitFullscreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen(); // IE
        }
      } catch (e) {
        Q.log(e);
      }
    },
    mapHighlightTargetElement(evt, target) {
      if (target) {
        const elements = [];
        if (target instanceof Q.Node) {
          elements.push(target);
          target.forEachEdge((edge) => {
            elements.push(edge);
            elements.push(edge.otherNode(target));
          });
        } else if (target instanceof Q.Edge) {
          elements.push(target);
          elements.push(target.from);
          elements.push(target.to);
        }
        MapInfo.getInstance(this).highlightElements(elements);
      } else {
        MapInfo.getInstance(this).unhighlightElements();
      }
      this.$mapEventBus.$emit(MapConst.MAP_EVENTBUS.AUTOMAP_DEVICE_HIGHLIGHT, null);
    },
    updateZoom() {
      if (!this.getRefreshMapParam().fit) {
        this.zoomReset();
      } else {
        this.zoomFit();
      }
    },
    cancelToken(token) {
      if (token) {
        token.cancel();
      }
    },
  },
};
</script>
<style module>
.main {
  position: relative;
  width: 100%;
  height: 100%;
}
.graph-area {
  height: 100%;
  width: 100%;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/views/topologymap/layout/TopologymapCanvas.vue